module.exports = __webpack_public_path__ + "static/media/right-arrow.ddf26e49.svg";